module.exports = __webpack_public_path__ + "img/project.ebee8c75.png";